import { render } from "./devicedetail.html?vue&type=template&id=0be241f2&scoped=true&external"
import script from "./devicedetail.ts?vue&type=script&lang=js&external"
export * from "./devicedetail.ts?vue&type=script&lang=js&external"

import "./devicedetail.scss?vue&type=style&index=0&id=0be241f2&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be241f2"],['__file',"src/view/device/devicedetail/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0be241f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0be241f2', __exports__)) {
    api.reload('0be241f2', __exports__)
  }
  
  module.hot.accept("./devicedetail.html?vue&type=template&id=0be241f2&scoped=true&external", () => {
    api.rerender('0be241f2', render)
  })

}


export default __exports__